// extracted by mini-css-extract-plugin
export default {"projectsContainer":"Projects_projectsContainer__5qrxH","cardLoading":"Projects_cardLoading__M3RSu","spin":"Projects_spin__-OMsG"};